import 'prometheus.aaa.scss';
import 'prometheus.modern.scss';

import './theme.aaa.scss';
import './theme.modern.scss';

import { mount } from 'svelte';
import { registerDocumentClickBubblingOnTop } from '@itslearning/atlas/frames/IframeClickEventHelper';
import { sendDocumentTitleToParent } from '@itslearning/atlas/frames/IFrameTitleUtils';

import App from './lib/App/App.svelte';
import { loadLangs } from './lang/loader';
import type { SvelteComponent } from 'svelte';
import type { AntiForgery, FilterOption, CatalogueCoursesModel } from './api/api.ts';

export interface CatalogueCourseData {
  title: string;
  antiForgery: AntiForgery;
  backUrl: string;
  targetRoles: FilterOption[];
  subjects: FilterOption[];
  educationalLevels: FilterOption[];
  organisations: FilterOption[];
  courses: CatalogueCoursesModel;
  lang: {
        currentCultureName: string;
        isHigherEducationEnabled: boolean;
    };
  isExternal: boolean;
  applicationRejectedCourseTitle: string;
  enrolledCourseIds : number[];
}

declare global {
    interface Window {
        CatalogueCourseModel: CatalogueCourseData;
    }
}

// @ts-ignore
const data = window.CatalogueCourseModel;

registerDocumentClickBubblingOnTop();
sendDocumentTitleToParent(data.title);

await loadLangs(data.lang);


const app = mount(App, {
    target: document.getElementById('course-catalogue')!,
    props: data
});

export default app;

